// import React, { useMemo } from 'react';
// import MarketIntelligenceFeedWidget from '../MarketIntelligence/MarketIntelligenceFeedWidget';
// import useMarketIntelligenceStore from '../Stores/marketIntelligenceStore';
// import '../Styles/MarketIntelligencePage.css';
//
// /**
//  * Manual frontend display schedule.
//  *
//  * This does NOT change backend data.
//  * Backend still sends the full current-day feed.
//  * This page decides which module posts are relevant to show right now.
//  *
//  * Times are ET.
//  */
// const MODULE_DISPLAY_WINDOWS = {
//   first_flows: {
//     start: '09:30',
//     end: '11:15',
//   },
//   zero_gex: {
//     start: '9:30',
//     end: '14:00',
//   },
//   trend: {
//     start: '11:00',
//     end: '14:00',
//   },
//   eod_range: {
//     start: '14:00',
//     end: '23:05',
//   },
//   orchestrator: {
//     start: '09:30',
//     end: '23:05',
//   },
// };
//
// /**
//  * Change this to 'all_day' if you want to show every post.
//  *
//  * Options:
//  * - 'current_session'
//  * - 'all_day'
//  */
// const FEED_MODE = 'current_session';
//
// function timeToMinutes(timeString) {
//   if (!timeString || typeof timeString !== 'string') return null;
//
//   const [hourRaw, minuteRaw] = timeString.split(':');
//   const hour = Number(hourRaw);
//   const minute = Number(minuteRaw);
//
//   if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
//
//   return hour * 60 + minute;
// }
//
// function getCurrentEtMinutes() {
//   const formatter = new Intl.DateTimeFormat('en-US', {
//     timeZone: 'America/New_York',
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: false,
//   });
//
//   const parts = formatter.formatToParts(new Date());
//
//   const hour = Number(parts.find((part) => part.type === 'hour')?.value);
//   const minute = Number(parts.find((part) => part.type === 'minute')?.value);
//
//   if (Number.isNaN(hour) || Number.isNaN(minute)) {
//     return null;
//   }
//
//   return hour * 60 + minute;
// }
//
// function getCurrentEtTimeLabel() {
//   const formatter = new Intl.DateTimeFormat('en-US', {
//     timeZone: 'America/New_York',
//     hour: 'numeric',
//     minute: '2-digit',
//     hour12: true,
//   });
//
//   return formatter.format(new Date());
// }
//
// function getPostModule(post) {
//   return post?.source_module || post?.sourceModule || 'orchestrator';
// }
//
// function isModuleInCurrentWindow(moduleName, nowEtMinutes) {
//   if (nowEtMinutes == null) return true;
//
//   const window = MODULE_DISPLAY_WINDOWS[moduleName];
//
//   if (!window) return true;
//
//   const startMinutes = timeToMinutes(window.start);
//   const endMinutes = timeToMinutes(window.end);
//
//   if (startMinutes == null || endMinutes == null) return true;
//
//   return nowEtMinutes >= startMinutes && nowEtMinutes <= endMinutes;
// }
//
// function filterPostsByDisplaySchedule(posts, nowEtMinutes) {
//   if (!Array.isArray(posts)) return [];
//
//   if (FEED_MODE === 'all_day') {
//     return posts;
//   }
//
//   return posts.filter((post) => {
//     const moduleName = getPostModule(post);
//     return isModuleInCurrentWindow(moduleName, nowEtMinutes);
//   });
// }
//
// function getActiveDisplayModules(nowEtMinutes) {
//   return Object.entries(MODULE_DISPLAY_WINDOWS)
//     .filter(([moduleName]) => isModuleInCurrentWindow(moduleName, nowEtMinutes))
//     .map(([moduleName]) => moduleName);
// }
//
// export default function MarketIntelligencePage() {
//   const visibleFrontendPosts = useMarketIntelligenceStore(
//     (state) => state.visibleFrontendPosts
//   );
//
//   const recentFrontendPosts = useMarketIntelligenceStore(
//     (state) => state.recentFrontendPosts
//   );
//
//   const connectionStatus = useMarketIntelligenceStore(
//     (state) => state.connectionStatus
//   );
//
//   const isAuthenticated = useMarketIntelligenceStore(
//     (state) => state.isAuthenticated
//   );
//
//   const authError = useMarketIntelligenceStore((state) => state.authError);
//   const error = useMarketIntelligenceStore((state) => state.error);
//   const tradingDate = useMarketIntelligenceStore((state) => state.tradingDate);
//   const lastMessageAt = useMarketIntelligenceStore((state) => state.lastMessageAt);
//
//   const nowEtMinutes = getCurrentEtMinutes();
//   const nowEtLabel = getCurrentEtTimeLabel();
//
//   const allPosts =
//     Array.isArray(recentFrontendPosts) && recentFrontendPosts.length > 0
//       ? recentFrontendPosts
//       : visibleFrontendPosts || [];
//
//   const posts = useMemo(() => {
//     return filterPostsByDisplaySchedule(allPosts, nowEtMinutes);
//   }, [allPosts, nowEtMinutes]);
//
//   const activeDisplayModules = useMemo(() => {
//     return getActiveDisplayModules(nowEtMinutes);
//   }, [nowEtMinutes]);
//
//   console.log('[MIS PAGE] connectionStatus:', connectionStatus);
//   console.log('[MIS PAGE] isAuthenticated:', isAuthenticated);
//   console.log('[MIS PAGE] tradingDate:', tradingDate);
//   console.log('[MIS PAGE] lastMessageAt:', lastMessageAt);
//   console.log('[MIS PAGE] visibleFrontendPosts:', visibleFrontendPosts);
//   console.log('[MIS PAGE] recentFrontendPosts:', recentFrontendPosts);
//   console.log('[MIS PAGE] feedMode:', FEED_MODE);
//   console.log('[MIS PAGE] nowEtLabel:', nowEtLabel);
//   console.log('[MIS PAGE] activeDisplayModules:', activeDisplayModules);
//   console.log('[MIS PAGE] rendered posts:', posts);
//
//
//     return (
//       <main className="misPage">
//         <MarketIntelligenceFeedWidget posts={posts || []} />
//       </main>
//     );
// }



///No time filtering.
import React from 'react';
import MarketIntelligenceFeedWidget from '../MarketIntelligence/MarketIntelligenceFeedWidget';
import useMarketIntelligenceStore from '../Stores/marketIntelligenceStore';
import '../Styles/MarketIntelligencePage.css';

export default function MarketIntelligencePage() {
  const visibleFrontendPosts = useMarketIntelligenceStore(
    (state) => state.visibleFrontendPosts
  );

  const recentFrontendPosts = useMarketIntelligenceStore(
    (state) => state.recentFrontendPosts
  );

  const connectionStatus = useMarketIntelligenceStore(
    (state) => state.connectionStatus
  );

  const isAuthenticated = useMarketIntelligenceStore(
    (state) => state.isAuthenticated
  );

  const authError = useMarketIntelligenceStore((state) => state.authError);
  const error = useMarketIntelligenceStore((state) => state.error);
  const tradingDate = useMarketIntelligenceStore((state) => state.tradingDate);
  const lastMessageAt = useMarketIntelligenceStore((state) => state.lastMessageAt);

  const posts =
    Array.isArray(recentFrontendPosts) && recentFrontendPosts.length > 0
      ? recentFrontendPosts
      : visibleFrontendPosts || [];

  // console.log('[MIS PAGE] connectionStatus:', connectionStatus);
  // console.log('[MIS PAGE] isAuthenticated:', isAuthenticated);
  // console.log('[MIS PAGE] tradingDate:', tradingDate);
  // console.log('[MIS PAGE] lastMessageAt:', lastMessageAt);
  // console.log('[MIS PAGE] visibleFrontendPosts:', visibleFrontendPosts);
  // console.log('[MIS PAGE] recentFrontendPosts:', recentFrontendPosts);
  // console.log('[MIS PAGE] rendered posts:', posts);
  // console.log('[MIS PAGE] authError:', authError);
  // console.log('[MIS PAGE] error:', error);

  return (
    <main className="misPage">
      <MarketIntelligenceFeedWidget posts={posts || []} />
    </main>
  );
}